import React from 'react';
import { Link } from 'react-router-dom';
import { FaShieldAlt, FaSearchengin, FaChartLine } from 'react-icons/fa';
import Hero from '../components/Hero';
import ServiceCard from '../components/ServiceCard';
import homeData from '../data/home.json';
import './Home.css';

const Home: React.FC = () => {
  return (
    <div className="home-page">
      <Hero
        heading={homeData.hero.heading}
        subheading={homeData.hero.subheading}
        backgroundImage={homeData.hero.backgroundImage}
        ctaText={homeData.hero.ctaText}
        ctaLink={homeData.hero.ctaLink}
      />

      {/* Introduction */}
      <section className="section">
        <div className="container">
          <div className="intro-section">
            <div className="orange-divider" />
            <h2 className="section-heading">{homeData.introduction.heading}</h2>
            <p className="intro-text">{homeData.introduction.text}</p>
          </div>
        </div>
      </section>

      {/* Approach */}
      <section className="section section-dark">
        <div className="container">
          <div className="approach-grid">
            <div className="approach-content">
              <div className="orange-divider" />
              <h2 className="section-heading">{homeData.approach.heading}</h2>
              <p className="approach-text">{homeData.approach.text}</p>
              <div className="approach-features">
                <div className="approach-feature">
                  <FaSearchengin className="approach-icon" />
                  <span>Gap Analysis</span>
                </div>
                <div className="approach-feature">
                  <FaShieldAlt className="approach-icon" />
                  <span>Risk Categorization</span>
                </div>
                <div className="approach-feature">
                  <FaChartLine className="approach-icon" />
                  <span>Continuous Advisory</span>
                </div>
              </div>
            </div>
            <div className="approach-image">
              <img src={homeData.approach.image} alt="Our Consulting Approach" loading="lazy" />
            </div>
          </div>
        </div>
      </section>

      {/* Leadership */}
      <section className="section">
        <div className="container">
          <div className="leadership-grid">
            <div className="leadership-image">
              <img src={homeData.leadership.image} alt="Expert Leadership" loading="lazy" />
            </div>
            <div className="leadership-content">
              <div className="orange-divider" />
              <h2 className="section-heading">{homeData.leadership.heading}</h2>
              <p className="leadership-text">{homeData.leadership.text}</p>
              <Link to={homeData.leadership.ctaLink} className="btn btn-primary">
                {homeData.leadership.ctaText}
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Service Portfolio */}
      <section className="section section-dark">
        <div className="container">
          <div className="portfolio-header">
            <div className="orange-divider" />
            <h2 className="section-heading">{homeData.portfolio.heading}</h2>
            <p className="section-subheading">{homeData.portfolio.subheading}</p>
          </div>
          <div className="portfolio-grid">
            {homeData.portfolio.services.map((service, idx) => (
              <ServiceCard
                key={idx}
                title={service.title}
                description={service.description}
                ctaText={service.ctaText}
                ctaLink={service.ctaLink}
                image={service.image}
              />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
